module.exports = __webpack_public_path__ + "media/images/svg/faq-up-7228feb6967f2d74135c93c85b964648.svg";